import { IOption } from '@/types/global'

export const speedTypeOptions: IOption<number>[] = [
  { title: '1.00x', value: 1 },
  { title: '1.25x', value: 1.25 },
  { title: '1.50x', value: 1.5 },
  { title: '1.75x', value: 1.75 },
  { title: '2.00x', value: 2 },
  { title: '4.00x', value: 4 }, // premium 9.99$ per month
]

const maxRangeMin = 10

const minRangeSec = 10

const autoStartDelaySec = 3

const playerWidgetConstants = { speedTypeOptions, maxRangeMin, autoStartDelaySec, minRangeSec }

export default playerWidgetConstants
